module.exports = __webpack_public_path__ + "img/mastercard_white.104a3274.svg";